var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12871",
    "data-name": "Group 12871",
    transform: "translate(-347.924 -1646.924)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 43,
    cy: 43,
    r: 43,
    transform: "translate(347.924 1646.924)",
    fill: "#006341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "play-svgrepo-com",
    d: "M5.92,34.667A3.158,3.158,0,0,0,7.388,37.4a3.456,3.456,0,0,0,1.721.455,3.144,3.144,0,0,0,1.417-.354L36.084,24.747a3.474,3.474,0,0,0,1.265-1.164,2.758,2.758,0,0,0,.455-1.721,3.714,3.714,0,0,0-.455-1.67,3.043,3.043,0,0,0-1.265-1.164L10.526,6.274A3.144,3.144,0,0,0,9.108,5.92a3.649,3.649,0,0,0-1.721.455A3.08,3.08,0,0,0,5.92,9.108V34.667Z",
    transform: "translate(371.852 1668.165)",
    fill: "#f4ea5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.dfbb8ecd23489b17a3a8bcebd632d91a.svg";
export { ForwardRef as ReactComponent };